import styled from "@emotion/styled"
import { MenuItem, Select, Tab, Tabs } from "@mui/material"
import colors from "theme/colors"
import { Desktop, Mobile } from "ui"
import { MapSection } from "./types"

const StyledTabs = styled(Tabs)`
  border-bottom: 1px solid #bad2d4;
  margin-bottom: 32px;
  .MuiTab-root {
    color: ${colors.black};
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    padding-bottom: 0px;
    border-bottom: 6px solid transparent;
    ${(props) => props.theme.breakpoints.up("md")} {
      font-size: 20px;
    }
  }
  .Mui-selected {
    border-bottom: 4px solid ${colors.yellow};
    color: ${colors.black};
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 28px;
    ${(props) => props.theme.breakpoints.up("md")} {
      font-size: 20px;
    }
  }
  .MuiTabs-flexContainer {
    ${(props) => props.theme.breakpoints.up("md")} {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
    }
  }
  button {
    display: flex;
    justify-content: flex-start;
  }
`
const StyledSelectWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 25px 20px 15px;
`

const StyledTab = styled(Tab)`
  :focus-visible{
    border: 1px solid gray;
  }
`

function a11yProps(index: number) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  }
}

function PazomatTabs({
  value,
  handleChange,
  sections,
}: {
  value: number
  handleChange: (newValue: number) => void
  sections: MapSection[]
}) {
  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    handleChange(newValue)
  }

  const handleSelectChange = (e: any) => {
    handleChange(e.target.value as number)
  }

  return (
    <>
      <Desktop>
        <StyledTabs
          value={value}
          onChange={handleTabChange}
          aria-label="שירותים שונים"
          variant="fullWidth"
        >
          {sections.map((section, index) => (
            <StyledTab
              disableRipple
              key={index.toString()}
              label={section.name}
              {...a11yProps(index)}
            />
          ))}
        </StyledTabs>
      </Desktop>
      <Mobile>
        <StyledSelectWrapper>
          <Select
            labelId={`mobile-services-label`}
            id="mobile-services"
            value={value || 0}
            onChange={handleSelectChange}
            aria-label="שירותים שונים"
            sx={{
              borderRadius: "24px",
              width: "100%",
              height: 40,
            }}
            SelectDisplayProps={{
              style: {
                paddingTop: 0,
                paddingBottom: 0,
                alignSelf: "center",
                fontSize: 16,
                fontWeight: 500,
              },
            }}
          >
            {sections.map((section, index) => (
              <MenuItem key={index} value={index}>
                {section.name}
              </MenuItem>
            ))}
          </Select>
        </StyledSelectWrapper>
      </Mobile>
    </>
  )
}

export default PazomatTabs
